/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyZloty = createReactComponent("currency-zloty", "IconCurrencyZloty", [
  ["path", { d: "M12 18h-7l7 -7h-7", key: "svg-0" }],
  ["path", { d: "M17 18v-13", key: "svg-1" }],
  ["path", { d: "M14 14.5l6 -3.5", key: "svg-2" }]
]);

export { IconCurrencyZloty as default };
//# sourceMappingURL=IconCurrencyZloty.js.map
